<template>
  <div class="cp_orientation">
      <div class="horizon_box">
          <div class="horizon_pic"><i></i></div>
          <span>为了更好的体验，请将手机竖过来哦~</span>
      </div>
  </div>
</template>

<script>

export default {
  mounted: function () {
  }
};
</script>

<style lang="stylus" rel="stylesheet/stylus">
.cp_orientation
  width: 100%;
  height: 100%;
  background: #000;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 99;

  .horizon_box
      width: 100%;
      height: 2.52rem;
      position: absolute;
      top: 50%;
      left: 0;
      margin-top: -1.19rem;

      .horizon_pic
          width: 1.01rem;
          height: 1.71rem;
          background: url(./images/pm.jpg) 0 0 no-repeat;
          background-size: 1.01rem 1.71rem;
          margin: 0 auto;
          position: static;
          display: block;
      span
          font-size: 0.16rem;
          display: block;
          color: #a69d6e;
          text-align: center;
          padding-top: 0.10rem;
</style>
